import React from 'react';

export default function HackingSectionCallToAction8() {
    return (
        <React.Fragment>
            <>
                <section className="py-20">
  <div className="container px-4 mx-auto">
    <div className="flex flex-wrap items-center -mr-16 -my-16">
      <div className="w-full md:w-1/2 mb-12 md:mb-0">
        <div className="lg:max-w-md">
          <h2 className="mb-4 lg:mb-8 text-4xl lg:text-5xl font-bold font-heading">Hacking - S0 - 说明书</h2>
          <p className="mb-6 text-lg text-gray-500 leading-loose">更多关于活动的细节可以参考以下文档。</p>
          <a className="inline-block px-6 py-2 text-sm text-white font-bold leading-loose bg-gray-600 hover:bg-gray-700 rounded transition duration-200" href="https://choooong.notion.site/Hacking-a0ae816a5d814e6ea6b507336f08b908?pvs=4">说明书</a>
        </div>
      </div>
      <div className="w-full md:w-1/2">
        <img className="w-full rounded-lg object-cover h-full items-center scale-150 -ml-8" src="https://static.shuffle.dev/uploads/files/9d/9d10ed0533a2f5a309eabf70e599971ed8a7e37a/RD5.png" alt />
      </div>
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

